import { Utils } from '../../utils';
import * as moment from 'moment';
import * as ko from "knockout";
import * as fs from 'fs';
import { RNSAPI } from "../../api";

export class DataTableViewModel {
    numberOfItems: KnockoutObservable<number>
    numberOfPages: KnockoutComputed<number>
    currentPage = ko.observable(0)
    columns: Array<string>
    columnHeaders: Array<string>
    entries: KnockoutComputed<Array<any>>
    allItems: KnockoutObservableArray<any>
    filteredItems: KnockoutComputed<any>
    filter = ko.observable("");
    emptyMessage: string
    //this refers to the separate action column (the one with icons)
    hasActions: boolean
    isEmpty: KnockoutComputed<boolean>
    hasButton = ko.observable(false);
    hasDTLayout = ko.observable(true);

    selectedElement = ko.observable(null);


    previous = () => this.currentPage(Math.max(0, this.currentPage() - 1));
    first = () => this.currentPage(0);

    next = () => this.currentPage(Math.min(this.numberOfPages() - 1, this.currentPage() + 1));
    last = () => this.currentPage(this.numberOfPages() - 1);
    

    resetFilter = () => this.filter("");

    executeAction = (elem: any, handler: any) => {
        if (handler.selectable) {
            this.selectedElement(elem);
        }
        
        handler.action();
        //this.showYNDia(); 
    }

    showYNDia = async () => {
        //console.log("Test");
        //$('#YNDialog').modal('show');
        //$('#YesNoModal').modal('show');
        //html file noch richtig einbinden 19102018
    }

    newDeadline = async () => {
        //console.log("Test Modal Deadline");
        $('#NewDeadlineDialog').modal('show');        
    }

    newResubmission = async () => {
        //console.log("Test Modal Deadline");
        $('#NewResubmissionDialog').modal('show');
    }

    pickCase = async () => {
        $('#modal').modal('show');
    }

    hasColumnAction = (parent: any, data: any) => parent.columnActions && parent.columnActions[data];
    hasTooltip = (parent: any, data: any) => parent.columnTooltips && parent.columnTooltips[data];

    postprocess = (elements: Array<HTMLElement>) => {
        //IE 11 does not support .find() so we make a for loop with early break 
        for (let element of elements) {
            if (element.classList && element.classList.contains("tooltip-container")) {
                $(element).tooltip();
                break;
            }
        }
    };

    async DeleteTodo(){
        //console.log("Test");
    }

    constructor(params: any) {
        this.columns = params.columns;
        this.columnHeaders = params.columnHeaders;
        this.emptyMessage = params.emptyMessage;
        this.hasActions = params.hasActions;
        this.allItems = params.entries;
        this.numberOfItems = ko.observable(params.numberOfItems || 10);
        this.hasButton = params.hasButton;
        this.hasDTLayout = params.hasDTLayout;


        this.numberOfItems.subscribe(() => this.currentPage(0));

        this.filteredItems = ko.computed({
            owner: this,
            read: () => {
                let filter = this.filter().toLowerCase();
                let items = this.allItems();
                return items.filter(item => {
                    for (let value of this.columns.map(column => item[column]) as Array<string>) {
                        if (value && value.toLowerCase().indexOf(filter) !== -1) return true;
                    }
                    return false;
                });
            }
        });

        this.isEmpty = ko.computed({
            owner: this,
            read: () => {
                return this.filteredItems().length === 0;
            }
        });

        this.numberOfPages = ko.computed({
            owner: this,
            read: () => {
                return Math.ceil(this.filteredItems().length / +this.numberOfItems());
            }
        });

        this.numberOfPages.subscribe(newNumberOfPages => this.currentPage(Math.max(0, Math.min(newNumberOfPages - 1, this.currentPage()))));

        this.entries = ko.computed({
            owner: this,
            read: () => {
                let numberOfItems = +this.numberOfItems();
                let items = this.filteredItems();
                let currentPage = this.currentPage();

                return Utils.partition(items, numberOfItems)[currentPage];
            }
        });
    }
}

export interface Color {
    color: string
    "background-color": string
}

export class IntermediateListItem {
    entryType: string
    entryTypeName: string
    date: string
    dateObj: moment.Moment
    subject: string
    number: string
    originalObj: any
    actionHandlers: any
    color: Color

    constructor(entryType: string, entryTypeName: string, date: string, subject: string, number: string, originalObj: any, actionHandlers?: any, color?: Color) {
        this.entryType = entryType;
        this.entryTypeName = entryTypeName;
        this.dateObj = moment.utc(date);
        this.date = this.dateObj.format("DD.MM.YYYY");
        this.subject = subject;
        this.number = number;
        this.originalObj = originalObj;
        this.actionHandlers = actionHandlers || [{ name: "Vorschau", action: () => { alert("Aktion für Typ: " + this.entryType) } }];
        this.color = color;
    }
};

var html = fs.readFileSync(__dirname + '/dataTable.html', 'utf8');

ko.components.register("data-table", {
    viewModel: DataTableViewModel,
    template: html
});